// ModuleSettingsContext.js (now AdminSettingsContext.js)
import React, { createContext, useContext, useState, useEffect } from "react";
import { getLocalStorageItem, setLocalStorageItem } from "../../common/LocalStorageService";

const ModuleSettingsContext = createContext();

export const useModuleSettings = () => useContext(ModuleSettingsContext);

export const ModuleSettingsProvider = ({ children }) => {
    const defaultSettings = {
        filter: "all",
        search: "",
        page: 1,
        limit: 10,  
        lang: "ENGLISH",
    };

    const [settings, setSettings] = useState(getLocalStorageItem("adminSettings", defaultSettings));

    useEffect(() => {
        setLocalStorageItem("adminSettings", settings);
    }, [settings]);

    const setFilter = (filter) => {
        setSettings((prev) => ({ ...prev, filter }));
    };

    const setSearch = (search) => {
        setSettings((prev) => ({ ...prev, search }));
    };

    const setPage = (page) => {
        setSettings((prev) => ({ ...prev, page }));
    };

    const setLimit = (limit) => {
        setSettings((prev) => ({ ...prev, limit }));
    };

    const setLang = (lang) => {
        setSettings((prev) => ({ ...prev, lang }));
    };

    const resetSettings = () => {
        setSettings(defaultSettings);
    };

    return (
        <ModuleSettingsContext.Provider value={{ ...settings, setFilter, setSearch, setPage, setLimit, setLang, resetSettings }}>
            {children}
        </ModuleSettingsContext.Provider>
    );
};
